<template>
  <div>
    <vs-popup
      :title="$t('ShelfProductList') + ' (' + ShelfCode + ') '"
      button-cancel="border"
      :active.sync="isSidebarActiveLocal"
      classContent="popup-example"
      fullscreen
    >
      <vs-card>
        <ag-grid-vue
          ref="agGridTable"
          class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
          :columnDefs="columns"
          :defaultColDef="defaultColDef"
          :rowData="processList"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          @grid-ready="onGridReady"
          :suppressCopyRowsToClipboard="true"
          :localeText="localeText"
          :suppressRowClickSelection="true"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </vs-card>
      <vs-popup
        class="holamundo"
        :title="$t('ShelfProductTransfer')"
        :active.sync="isSidebarActiveTransferProduct"
      >
        <vs-card>
          <b-row class="mt-2">
            <p class="mb-0">{{ $t("Shelf") }}</p>

            <v-select
              color="danger"
              v-model="shelf"
              :options="shelf_choices"
              size="small"
              label="name"
              autocomplete
              ref="selectElement"
              name="shelf"
              v-validate="'required'"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('shelf')">{{
              errors.first("shelf")
            }}</span>
          </b-row>
          <b-row style="margin-top: 25px">
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="username"
              id="quantity"
              ref="quantity"
              :label-placeholder="$t('Quantity')"
              v-model="quantity"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('quantity')">{{
              errors.first("quantity")
            }}</span>
          </b-row>
          <div class="items-center pl-6 mt-5 mb-0">
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="saveAllList()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </vs-card>
        <vs-prompt
          :title="$t('Warning')"
          :acceptText="$t('Submit')"
          :cancelText="$t('Cancel')"
          @accept="saveData"
          :active.sync="isSidebarActiveCompleteProcess"
          color="primary"
        >
          <div style="text-align: center" class="con-exemple-prompt">
            <span>
              <b-row style="margin-top: 15px">
                <b-col cols="12" align-self="center">
                  <h6>{{ $t("DoConfirm") }}</h6>
                </b-col>
              </b-row>
            </span>
          </div>
        </vs-prompt>
      </vs-popup>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import getShelfTransStatus from "./CellRenderers/getShelfTransStatus.vue";
import moment from "moment";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import vSelect from "vue-select";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
    ShelfCode: "",
  },
  data() {
    return {
      productForTransfer: "",
      isSidebarActiveCompleteProcess: false,
      quantity: 0,
      shelf: "",
      shelf_choices: [],
      isSidebarActiveTransferProduct: false,
      addNewInfoDataSidebar: false,
      isPromptActiveShelfLocal: false,
      addNewActSidebar: false,
      infoData: [],
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    uuid,
    vSelect,
    detailBtnCellRenderer,
    getShelfTransStatus,
    AgGridVue,
    Icon,
  },
  methods: {
    saveData(index) {
      const vs = this.$vs;
      var createdId = uuid.v4();
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            shelfTransId: createdId,
            barcode: this.productForTransfer.Barcode,
            quantity: this.quantity,
            shelfTransStatus: false,
            corridorCode: this.productForTransfer.CorridorCode,
            shelfCode: this.productForTransfer.ShelfCode,
            companyCode: this.productForTransfer.CompanyCode,
          };
          console.log(obj);
          this.$store
            .dispatch("storehouse/addShelfTrans", obj)
            .then((response) => {
              if (response.status == 200) {
                try {
                  obj.shelfCode = this.shelf.code;
                  obj.shelfTransStatus = true;
                  console.log(obj);

                  this.$store
                    .dispatch("storehouse/addShelfTrans", obj)
                    .then((response) => {
                      if (response.status == 200) {
                        try {
                          this.isSidebarActiveTransferProduct = false;
                          this.shelf = "";
                          this.quantity = 0;
                          vs.notify({
                            text: this.$t("TransferComplete"),
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "success",
                            position: "top-center",
                          });
                        } catch (error) {
                          vs.notify({
                            text: error.toString(),
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "danger",
                            position: "top-center",
                          });
                        }
                      } else
                        vs.notify({
                          text: response.data.message.toString(),
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "danger",
                          position: "top-center",
                        });
                    })
                    .catch((error) => {
                      return new Promise((resolve, reject) => {
                        resolve(false);
                      });
                    });
                } catch (error) {
                  vs.notify({
                    text: error.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              } else
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    saveAllList() {
      this.isSidebarActiveCompleteProcess = true;
    },
    getShelfList() {
      this.shelf_choices = [];
      this.$store.dispatch("storehouse/listShelf").then((response) => {
        if (response.success == true) {
          if (JSON.parse(response.json)) {
            JSON.parse(response.json).forEach((val, index) => {
              this.shelf_choices.push({
                value: val.ShelfId,
                code: val.ShelfCode,
                name: val.ShelfName,
              });
            });
          }
        } else console.log(response.statusText);
      });
    },
    closeTransferProduct() {
      this.isSidebarActiveTransferProduct = false;
    },
    closeShelfData() {
      this.isPromptActiveShelfLocal = false;
    },

    onFirstDataRendered(params) {
    //  params.api.sizeColumnsToFit();
    },
    toggleActSidebar(val = false) {
      this.addNewActSidebar = val;
    },
    transferProduct() {
      console.log(this.productForTransfer);
      this.isSidebarActiveTransferProduct = true;
      this.getShelfList();
    },
    getShelfColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 70,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "transferProduct",
						tooltip:"TransferShelf",
            iconDetail: "lets-icons:transger",
            iconColor: "#065a82",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val == "ShelfTransStatus") {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "getShelfTransStatus",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    addShelfData() {
      const vs = this.$vs;
      this.processList = [];
      this.$store
        .dispatch("storehouse/listShelfTransForShelf", this.ShelfCode)
        .then((response) => {
          if (response.success == true) {
            try {
              this.processList = JSON.parse(response.json);
              this.getShelfColumnList();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },

  watch: {
    isSidebarActive(val) {
      if (val == true) this.addShelfData();
      return val;
    },
  },

  mounted() {
    this.$root.$on("transferProduct", (param) => {
      this.productForTransfer = param;
      this.transferProduct();
    });
  },
  beforeDestroy() {
    this.$root.$off("transferProduct");
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
